import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';

export const kenModalButtonSx = {
  textTransform: 'none',
  borderRadius: '12px',
  minHeight: '42px',
  height: '42px',
  fontSize: '14px',
  fontWeight: 600,
  padding: '0 20px',
  boxShadow: 'none !important',
  border: '1px solid #E3E9F2',
  color: '#8B98AD',
  backgroundColor: '#FFFFFF',
  '&:hover': { boxShadow: 'none !important', backgroundColor: '#FAFBFD', borderColor: '#D2DCE9' },
  '&.Mui-disabled': { color: '#A4AAB4', backgroundColor: '#E6E8ED', borderColor: '#E6E8ED' },
};

export const kenModalPrimaryButtonSx = {
  ...kenModalButtonSx,
  color: '#FFFFFF',
  border: '1px solid #1688C8',
  background: 'linear-gradient(110deg, #1688C8 0%, #2AA7D0 100%)',
  boxShadow: '0 9px 20px rgba(24, 132, 194, 0.22) !important',
  '&:hover': {
    background: 'linear-gradient(110deg, #147FB9 0%, #259BC2 100%)',
    boxShadow: '0 9px 20px rgba(24, 132, 194, 0.26) !important',
  },
  '&.Mui-disabled': { color: '#9B9FA7', background: '#E1E3E8', borderColor: '#E1E3E8', boxShadow: 'none !important' },
};

export const kenModalFieldSx = {
  '& .MuiOutlinedInput-root': {
    height: '42px',
    borderRadius: '12px',
    backgroundColor: '#F5F7FB',
    fontSize: '16px',
    color: '#263246',
    '& fieldset': { border: '1px solid #E5EAF2' },
    '&:hover fieldset': { borderColor: '#CBD6E4' },
    '&.Mui-focused fieldset': { borderColor: '#2388C7', borderWidth: '1px' },
    '& input::placeholder': { color: '#737373', opacity: 1 },
  },
  '& .MuiFormHelperText-root': { margin: '5px 0 0', fontSize: '12px' },
};

export const kenModalLabelSx = { display: 'block', marginBottom: '7px', color: '#8B98AD', fontSize: '15px', lineHeight: 1.2 };

export const kenModalPaperSx = {
  borderRadius: '22px',
  width: '600px',
  maxWidth: 'calc(100% - 32px)',
  padding: '28px 28px 24px',
  boxShadow: '0 20px 45px rgba(31, 52, 79, 0.24)',
};

export const kenModalCloseSx = {
  width: '44px',
  height: '44px',
  border: '1px solid #E5EAF2',
  borderRadius: '14px',
  color: '#8B98AD',
  '& .MuiSvgIcon-root': { fontSize: '22px' },
};

/**
 * @param {{
 *   open: boolean,
 *   onClose: () => void,
 *   title: import('react').ReactNode,
 *   children: import('react').ReactNode,
 *   actions?: import('react').ReactNode,
 *   width?: string,
 *   paperSx?: object,
 *   contentSx?: object,
 *   actionsSx?: object,
 * }} props
 */
export default function KenModal({
  open,
  onClose,
  title,
  children,
  actions = null,
  width = null,
  paperSx = {},
  contentSx = {},
  actionsSx = {},
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      BackdropProps={{ sx: { backgroundColor: 'rgba(38, 56, 95, 0.46)' } }}
      PaperProps={{ sx: { ...kenModalPaperSx, ...(width ? { width } : {}), ...paperSx } }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 0, marginBottom: '28px' }}>
        <DialogTitle sx={{ padding: 0, fontSize: '20px', lineHeight: 1.2, fontWeight: 600, color: '#263246' }}>
          {title}
        </DialogTitle>
        <IconButton aria-label="close" onClick={onClose} sx={kenModalCloseSx}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ padding: 0, display: 'flex', flexDirection: 'column', gap: '20px', ...contentSx }}>
        {children}
      </DialogContent>
      {actions && <DialogActions sx={{ padding: '28px 0 0', gap: '12px', ...actionsSx }}>{actions}</DialogActions>}
    </Dialog>
  );
}
